import React from 'react';
import { notification, Select } from 'antd';
import { api, dialogApi } from 'services/api';

const NumberSelectors = ({ numbers, bitrix24, language, state, setState }) => {
	const handleChangeTo = (value) => {
		setState({ to: value });
	};

	const handleChangeFrom = async (index) => {
		const { domain, auth } = numbers.infos;
		const {
			placement: entityName,
			options: { ID: entityId },
		} = numbers.placement;
		const value = numbers.numbers.actives[index];

		setState({ from: value.number });
		setState({ fromApi: value.api });
		setState({ selectedTemplate: {} });
		setState({ templateList: [], templateListError: null });

		if (value.api === 'messageBird') {
			setState({ showTemplateButtons: false });
			setState({ showTemplateLayout: true, files: [] });
			getTemplateList(value.number, value.api);
		} else if (value.api === 'dialog') {
			setState({ showTemplateButtons: false });
			setState({ showTemplateLayout: true, files: [] });
			getTemplateList(value.number, value.api);
		} else if (value.api === 'zapi') {
			setState({ showTemplateButtons: true });
			setState({ showTemplateLayout: false });
			setState({ validateNumberFormat: true });
			setState({ onlyNational: value.remove_cc });
			setState({ isFromBrazil: value.country_code === 'br' });
		} else if (value.api === 'meta') {
			setState({ showTemplateButtons: false });
			setState({ showTemplateLayout: true, files: [] });
			getTemplatesListMeta(domain, value.token);
		} else {
			setState({ showTemplateButtons: false });
			setState({ showTemplateLayout: false });
		}

		const data = {
			domain,
			auth,
			entityId,
			entityName,
			fromNumber: value.number,
		};

		await verifyIfChatExistsInEntity(data);
	};

	const verifyIfChatExistsInEntity = async (data) => {
		setState({ loadingVerifyIfChatExistsInEntity: true });
		await api.post('verifyChat', data).then((res) => {
			setState({ loadingVerifyIfChatExistsInEntity: false });
			const { status } = res.data;
			if (status) {
				setState({ isChatExistsInEntity: true });
			} else {
				setState({ isChatExistsInEntity: false });
			}
		});
	};

	const getTemplatesListMeta = async (domain, token) => {
		const request = {
			params: {
				token,
				domain,
			},
		};

		try {
			const result = await api.get('getTemplates', request);
			if (result.data?.statusCode >= 400 || result.data?.error) {
				const errorData = result.data;
				const errorMessage = errorData.message || language.template_error;

				console.error('getTemplatesListMeta: Error response detected', errorData);

				setState({
					templateList: [],
					templateListError: {
						message: errorMessage,
						code: errorData.error?.code || errorData.statusCode,
						type: errorData.error?.type,
						fbtrace_id: errorData.error?.fbtrace_id,
						description: errorMessage,
					},
				});

				return;
			}

			setState({ templateList: result.data, templateListError: null });
		} catch (error) {
			setState({ templateList: [] });
			console.error('Error fetching template list:', error);
			const errorCode = error.response?.data?.errorCode;
			const errorMessage =
				errorCode && Object.prototype.hasOwnProperty.call(language, errorCode)
					? language[errorCode]
					: language.template_error;
			notification.error({ message: errorMessage });
		}
	};

	const getTemplateList = async (from, fromApi) => {
		const http = fromApi === 'dialog' ? dialogApi : api;
		const action = fromApi === 'dialog' ? 'template/get-template-list' : 'getTemplateList';
		const data = {
			action,
			api: fromApi,
			sender: from,
			domain: state.infos.domain,
			auth: state.infos.auth,
		};

		await http
			.post(action, data)
			.then(async (res) => {
				if (res.data.dados) {
					setState({ templateList: res.data.dados });
					if (res.data.dados.errors) {
						handleTemplateError();
					}
				} else {
					setState({ templateList: [] });
				}
			})
			.catch((e) => {
				setState({ templateList: [] });
				console.error('Error fetching template list:', e);
				const errorCode = e.response?.data?.errorCode;
				const errorMessage =
					errorCode && Object.prototype.hasOwnProperty.call(language, errorCode)
						? language[errorCode]
						: language.template_error;
				notification.error({ message: errorMessage });
			});
	};

	const handleTemplateError = () => {
		if (state.showTemplateLayout && state.templateList.errors) {
			let errorDescription = state.templateList.errors[0].description;

			if (errorDescription.includes('Request was not authenticated')) {
				errorDescription += '.\n\n' + language.invalid_tokens;
			} else if (
				errorDescription.includes('You cannot use the Integrations API with a test access key')
			) {
				errorDescription += '.\n\n' + language.using_test_tokens;
			}

			notification.error({
				message: language.template_error,
				description: errorDescription,
				duration: 0,
			});
		}
	};

	return (
		<div style={{ display: 'flex', gap: '10px', padding: 5, width: '100%' }}>
			<Select
				style={{ flex: 1 }}
				placeholder={language.select_source_number}
				onChange={handleChangeFrom}
				optionLabelProp="label"
				loading={numbers.loadingNumber}
			>
				{numbers.numbers.actives.map((number, index) => (
					<Select.Option
						key={number.id}
						value={index}
						label={number.name ? `${number.name} - ${number.number}` : number.number}
					>
						{number.name && (
							<span
								role="img"
								aria-label={number.name}
								style={{
									marginRight: 6,
									backgroundColor: '#bbed21',
									padding: 3,
									borderRadius: 10,
									minWidth: 30,
								}}
							>
								{number.name}
							</span>
						)}
						{number.number}
					</Select.Option>
				))}
			</Select>

			<Select
				mode="tags"
				style={{ flex: 1 }}
				placeholder={language.select_destination}
				loading={bitrix24.loadingListOfNumbers}
				onChange={handleChangeTo}
			>
				{bitrix24.listOfNumbers.map((element) => (
					<Select.Option
						key={element.ID}
						value={element.VALUE}
						selected={bitrix24.listOfNumbers.length === 1}
					>
						{element.VALUE}
					</Select.Option>
				))}
			</Select>
		</div>
	);
};

export default NumberSelectors;
